// ProtectedRoutes.js
import { Navigate } from 'react-router-dom';
import { useUser } from './Context/UserContext';  // 👈 USE CONTEXT

const ProtectedRoutes = ({ children }) => {
  const { isAuthenticated, loading } = useUser();

  if (loading) {
    return <div>Loading...</div>;  // 👈 Prevent flash
  }

  return isAuthenticated ? children : <Navigate to="/Home" replace />;
};

export default ProtectedRoutes;
